import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public confirmationMsg: string,
    public confirmationDialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {}

  ngOnInit() {
    this.confirmationDialogRef.addPanelClass("confirmation-dialog");
  }
}
